import { useMemo } from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

export function useTailwindConfig() {
  return useMemo(() => resolveConfig(tailwindConfig), [tailwindConfig]);
}
